import { action, observable } from 'mobx';
import { ToastProps } from '@honeybook/hbui/dist/components/HBToast/HBToast.types';

export class ToastStore {
    @observable toasts: Array<ToastProps> = [];

    @action
    add(toast: ToastProps) {
        const id = toast.id || String(Math.random());
        if (!this.toasts.some(t => t.id === id)) {
            this.toasts = [
                ...this.toasts,
                {
                    ...toast,
                    id
                }
            ];
        }
        return id;
    }

    byId(id: string) {
        return this.toasts.find(toast => toast.id === id);
    }

    @action.bound
    remove(id: string) {
        this.toasts = this.toasts.filter(toast => toast.id !== id);
    }
}
